import React, { useEffect, useRef, useState } from "react";
import "./Entertainment.css";
import Testimonial from "../../../Testimonial/Testimonial";
import { Helmet } from "react-helmet";

const Entertainment = () => {
   const techItemsRow1 = [
    { name: "Angular.js", logo: "/logos/angular.png" },
    { name: "HTML", logo: "/logos/html.png" },
    { name: "CSS3", logo: "/logos/css.png" },
    { name: "Bootstrap", logo: "/logos/bootstrap.png" },
    { name: "Javascript", logo: "/logos/javascript.png" },
    { name: "AmazonDB", logo: "/logos/amazon_dynamodb.png" },
    { name: "Appian", logo: "/logos/appian.png" },
    { name: "Laravel", logo: "/logos/laravel.png" },
    { name: "MariaDB", logo: "/logos/mariadb.png" },
    { name: "MongoDB", logo: "/logos/mongodb.png" },
    { name: "Android", logo: "/logos/android-5.png" },
    { name: "ERC-20", logo: "/logos/erc-20.png" },
    { name: "Ethereum", logo: "/logos/ethereum.png" },
    { name: "Flutter", logo: "/logos/flutter.png" },
    { name: "Ionic", logo: "/logos/ionic.png" },
    {
      name: "Artificial Intelligence",
      logo: "/logos/artificial-intelligence.png",
    },
    { name: "Augmented Reality", logo: "/logos/Augmented Reality.png" },
    { name: "Crda", logo: "/logos/crda.png" },
    { name: "Data Science", logo: "/logos/data-science.png" },
    { name: "Go Chain", logo: "/logos/gochain.png" },
  ];

  const techItemsRow2 = [
    { name: "Sass", logo: "/logos/saas.png" },
    { name: "JQuery", logo: "/logos/jquery.png" },
    { name: "Less", logo: "/logos/less.png" },
    { name: "Codeigniter", logo: "/logos/codeignitor.png" },
    { name: "Django", logo: "/logos/django.png" },
    { name: "Node JS", logo: "/logos/node js.png" },
    { name: "PHP", logo: "/logos/php.png" },
    { name: "Salesforce", logo: "/logos/salesforce.png" },
    { name: "SQL Server", logo: "/logos/sql-server.png" },
    { name: "MySQL", logo: "/logos/mysql-5.png" },
    { name: "IOS", logo: "/logos/ios.png" },
    { name: "Oracle 6", logo: "/logos/oracle.png" },
    { name: "PostgreSQL", logo: "/logos/postgresql.png" },
    { name: "React Native", logo: "/logos/react_native.png" },
    { name: "Solidity", logo: "/logos/Solidity.png" },
    { name: "Hyperledger", logo: "/logos/Hyperledger.png" },
    { name: "Internet Of Things", logo: "/logos/iot.png" },
    { name: "One Ledger", logo: "/logos/OneLedger.png" },
    { name: "Virtual Reality", logo: "/logos/virtual-reality.png" },
  ];

  const duplicatedRow1 = [...techItemsRow1, ...techItemsRow1];
  const duplicatedRow2 = [...techItemsRow2, ...techItemsRow2];

  const containerRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offset, setOffset] = useState(0);
  const animationRef = useRef();

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollSpeed = 1;

    const animate = () => {
      setOffset((prevOffset) => {
        const maxOffset = row1Ref.current?.scrollWidth / 2 || 0;
        const newOffset = prevOffset + scrollSpeed;
        return newOffset >= maxOffset ? 0 : newOffset;
      });
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [containerWidth]);

  const [showModal, setShowModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const consultationOptions = [
    {
      id: 1,
      title: "Streaming Platform Development",
      description:
        "Custom OTT and streaming solutions for content delivery and monetization",
      whatsappMessage:
        "Hello, I'm interested in Streaming Platform Development consultation.",
    },
    {
      id: 2,
      title: "Gaming & Interactive Experiences",
      description:
        "Immersive gaming solutions and interactive entertainment experiences",
      whatsappMessage:
        "Hello, I'm interested in Gaming & Interactive Experiences consultation.",
    },
    {
      id: 3,
      title: "Content Management Systems",
      description:
        "Advanced CMS solutions for media libraries and digital content distribution",
      whatsappMessage:
        "Hello, I'm interested in Content Management Systems consultation.",
    },
    {
      id: 4,
      title: "AR/VR Entertainment Solutions",
      description:
        "Cutting-edge augmented and virtual reality experiences for entertainment",
      whatsappMessage:
        "Hello, I'm interested in AR/VR Entertainment Solutions consultation.",
    },
    {
      id: 5,
      title: "Audience Engagement Platforms",
      description:
        "Tools to increase viewer interaction and community building",
      whatsappMessage:
        "Hello, I'm interested in Audience Engagement Platforms consultation.",
    },
    {
      id: 6,
      title: "Media Analytics & Insights",
      description:
        "Data-driven analytics for content performance and audience behavior",
      whatsappMessage:
        "Hello, I'm interested in Media Analytics & Insights consultation.",
    },
  ];

  const handleButtonClick = () => {
    setShowModal(true);
    setSelectedOption(null);
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  const handleWhatsAppRedirect = () => {
    if (selectedOption) {
      const message = encodeURIComponent(selectedOption.whatsappMessage);
      window.open(`https://wa.me/+919155599968?text=${message}`, "_blank");
      setShowModal(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedOption(null);
  };

  return (
    <div className="entertainment-sector-page">
      <Helmet>
        <title>
          Entertainment Technology Solutions | Digital Innovation for Media & Entertainment
        </title>
        <meta
          name="description"
          content="Explore our comprehensive entertainment technology solutions including streaming platforms, gaming experiences, AR/VR solutions, and content management systems."
        />
        <meta
          name="keywords"
          content="entertainment technology, streaming platforms, gaming development, AR/VR experiences, media solutions, OTT development, interactive entertainment, content management, audience engagement, media analytics"
        />
      </Helmet>

      {/* Hero Section */}
      <section className="entertainment-sector-hero">
        <div className="entertainment-sector-hero-content">
          <h1 className="entertainment-sector-hero-title">
            Revolutionizing{" "}
            <span className="entertainment-sector-highlight">
              Digital Entertainment
            </span>
          </h1>
          <p className="entertainment-sector-hero-description">
            We create immersive entertainment experiences that captivate audiences, 
            drive engagement, and transform how people consume media. From streaming 
            platforms to interactive gaming and cutting-edge AR/VR solutions.
          </p>
          <div className="entertainment-sector-hero-buttons">
            <a href="/contact-us">
              <button className="entertainment-sector-btn entertainment-sector-btn-primary">
                Get Started
              </button>
            </a>
            <button className="entertainment-sector-btn entertainment-sector-btn-secondary">
              Learn More
            </button>
          </div>
        </div>
        <div className="entertainment-sector-hero-visual">
          <div className="entertainment-sector-animated-stage">
            <div className="entertainment-sector-stage-platform"></div>
            <div className="entertainment-sector-spotlights"></div>
            <div className="entertainment-sector-audio-waves"></div>
          </div>
          <div className="entertainment-sector-orb entertainment-sector-orb-1"></div>
          <div className="entertainment-sector-orb entertainment-sector-orb-2"></div>
          <div className="entertainment-sector-orb entertainment-sector-orb-3"></div>
        </div>
      </section>

      {/* Services Section */}
      <section className="entertainment-sector-services">
        <div className="entertainment-sector-services-header">
          <h2 className="entertainment-sector-section-title">
            Our Entertainment Technology Solutions
          </h2>
          <p className="entertainment-sector-section-subtitle">
            Innovative entertainment technology services designed to create engaging experiences, 
            streamline content delivery, and maximize audience reach.
          </p>
        </div>

        <div className="entertainment-sector-services-grid">
          {/* Streaming Platform Card */}
          <div className="entertainment-sector-service-card">
            <div className="entertainment-sector-service-icon">
              <div className="entertainment-sector-icon entertainment-sector-icon-streaming"></div>
            </div>
            <h3>Streaming Platform Development</h3>
            <p>
              Custom OTT and streaming solutions for content delivery, monetization, and viewer engagement.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Multi-platform Support</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Content Monetization</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>DRM Protection</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>User Management</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">60%</div>
                <div className="stat-label">Faster Development</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">99.5%</div>
                <div className="stat-label">Uptime</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Gaming Development Card */}
          <div className="entertainment-sector-service-card">
            <div className="entertainment-sector-service-icon">
              <div className="entertainment-sector-icon entertainment-sector-icon-gaming"></div>
            </div>
            <h3>Gaming & Interactive Experiences</h3>
            <p>
              Immersive gaming solutions and interactive entertainment experiences across platforms.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Cross-platform Development</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Multiplayer Integration</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Game Mechanics Design</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Performance Optimization</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">70%</div>
                <div className="stat-label">Faster Development</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">4.8/5</div>
                <div className="stat-label">User Rating</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Content Management Card */}
          <div className="entertainment-sector-service-card">
            <div className="entertainment-sector-service-icon">
              <div className="entertainment-sector-icon entertainment-sector-icon-cms"></div>
            </div>
            <h3>Content Management Systems</h3>
            <p>
              Advanced CMS solutions for media libraries, digital content distribution, and workflow automation.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Media Library Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Automated Workflows</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Metadata Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Content Scheduling</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">50%</div>
                <div className="stat-label">Time Savings</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">3x</div>
                <div className="stat-label">Content Output</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* AR/VR Solutions Card */}
          <div className="entertainment-sector-service-card">
            <div className="entertainment-sector-service-icon">
              <div className="entertainment-sector-icon entertainment-sector-icon-arvr"></div>
            </div>
            <h3>AR/VR Entertainment Solutions</h3>
            <p>
              Cutting-edge augmented and virtual reality experiences for immersive entertainment.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Immersive Experiences</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>3D Environment Design</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Interactive Elements</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Multi-platform AR/VR</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">40%</div>
                <div className="stat-label">Higher Engagement</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">2.5x</div>
                <div className="stat-label">Longer Session Times</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Audience Engagement Card */}
          <div className="entertainment-sector-service-card">
            <div className="entertainment-sector-service-icon">
              <div className="entertainment-sector-icon entertainment-sector-icon-engagement"></div>
            </div>
            <h3>Audience Engagement Platforms</h3>
            <p>
              Tools to increase viewer interaction, community building, and fan engagement.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Interactive Features</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Community Building</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Social Integration</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Gamification Elements</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">65%</div>
                <div className="stat-label">Engagement Increase</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">80%</div>
                <div className="stat-label">Retention Rate</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Media Analytics Card */}
          <div className="entertainment-sector-service-card">
            <div className="entertainment-sector-service-icon">
              <div className="entertainment-sector-icon entertainment-sector-icon-analytics"></div>
            </div>
            <h3>Media Analytics & Insights</h3>
            <p>
              Data-driven analytics for content performance, audience behavior, and business intelligence.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Audience Insights</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Content Performance</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>ROI Measurement</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Predictive Analytics</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">45%</div>
                <div className="stat-label">Better Decisions</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">30%</div>
                <div className="stat-label">Revenue Growth</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Live Events Card */}
          <div className="entertainment-sector-service-card">
            <div className="entertainment-sector-service-icon">
              <div className="entertainment-sector-icon entertainment-sector-icon-live"></div>
            </div>
            <h3>Live Event Technology</h3>
            <p>
              End-to-end solutions for virtual and hybrid live events, concerts, and performances.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Live Streaming</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Virtual Venues</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Interactive Features</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Ticketing Integration</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">500k+</div>
                <div className="stat-label">Concurrent Viewers</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">99.9%</div>
                <div className="stat-label">Reliability</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Content Protection Card */}
          <div className="entertainment-sector-service-card">
            <div className="entertainment-sector-service-icon">
              <div className="entertainment-sector-icon entertainment-sector-icon-protection"></div>
            </div>
            <h3>Content Protection & DRM</h3>
            <p>
              Advanced security solutions to protect intellectual property and prevent unauthorized access.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Digital Rights Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Content Encryption</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Access Control</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Piracy Prevention</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">100%</div>
                <div className="stat-label">Content Security</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">0</div>
                <div className="stat-label">Security Breaches</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>
        </div>

        <div className="entertainment-sector-services-cta">
          <h3>Ready to transform your entertainment offerings?</h3>
          <p>
            Schedule a free consultation with our entertainment technology experts
            to discuss your specific needs.
          </p>
          <div className="services-cta-buttons">
            <div className="entertainment-sector-consultation-container">
              <button
                className="entertainment-sector-primary-btn entertainment-sector-pulse"
                onClick={handleButtonClick}
              >
                Book a Consultation
              </button>

              {showModal && (
                <div className="entertainment-sector-modal-overlay">
                  <div className="entertainment-sector-modal-content">
                    <button
                      className="entertainment-sector-close-btn"
                      onClick={handleCloseModal}
                    >
                      &times;
                    </button>

                    <h2 className="entertainment-sector-modal-title">
                      Entertainment Technology Consultation
                    </h2>
                    <p className="entertainment-sector-modal-subtitle">
                      Select an area you need consultation on:
                    </p>

                    <div className="entertainment-sector-options-grid">
                      {consultationOptions.map((option) => (
                        <div
                          key={option.id}
                          className={`entertainment-sector-option-card ${
                            selectedOption?.id === option.id ? "selected" : ""
                          }`}
                          onClick={() => handleOptionSelect(option)}
                        >
                          <h3 className="entertainment-sector-option-title">
                            {option.title}
                          </h3>
                          <p className="entertainment-sector-option-desc">
                            {option.description}
                          </p>
                        </div>
                      ))}
                    </div>

                    <button
                      className={`entertainment-sector-whatsapp-btn ${
                        selectedOption ? "active" : ""
                      }`}
                      onClick={handleWhatsAppRedirect}
                      disabled={!selectedOption}
                    >
                      Continue to WhatsApp
                    </button>
                  </div>
                </div>
              )}
            </div>
            <button className="entertainment-sector-btn entertainment-sector-btn-secondary">
              View Case Studies
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="entertainment-sector-stats">
        <div className="entertainment-sector-stats-container">
          <div className="entertainment-sector-stat">
            <h3 className="entertainment-sector-stat-number" data-count="200">
              90
            </h3>
            <p className="entertainment-sector-stat-label">Entertainment Projects</p>
          </div>
          <div className="entertainment-sector-stat">
            <h3 className="entertainment-sector-stat-number" data-count="98">
              75
            </h3>
            <p className="entertainment-sector-stat-label">Client Satisfaction</p>
          </div>
          <div className="entertainment-sector-stat">
            <h3 className="entertainment-sector-stat-number" data-count="15">
              11
            </h3>
            <p className="entertainment-sector-stat-label">Years Experience</p>
          </div>
          <div className="entertainment-sector-stat">
            <h3 className="entertainment-sector-stat-number" data-count="30">
              30
            </h3>
            <p className="entertainment-sector-stat-label">Countries Served</p>
          </div>
        </div>
      </section>

      {/* Tech Stack Section */}
      <div className="tech-slider-container" ref={containerRef}>
        <h2 className="tech-slider-title">Tools & Tech Stack</h2>
        <div className="tech-slider-divider"></div>

        {/* First row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row1Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow1.map((tech, index) => (
              <div key={`row1-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Second row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row2Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow2.map((tech, index) => (
              <div key={`row2-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <section className="entertainment-sector-cta">
        <div className="entertainment-sector-cta-content">
          <h2>Ready to Transform Your Entertainment Platform?</h2>
          <p>
            Contact us today to discuss how our entertainment technology expertise
            can help your organization innovate and captivate audiences.
          </p>
          <a href="/contact-us">
            <button className="entertainment-sector-btn entertainment-sector-btn-primary entertainment-sector-btn-large">
              Schedule a Consultation
            </button>
          </a>
        </div>
      </section>

      <Testimonial />
    </div>
  );
};

export default Entertainment;